/**
 * @prettier
 */
import * as React from 'react';
import { SvgIconProps } from 'src/types/icons/SvgIcon';

export function ChainIcon({ color, title, width, height, size, ...props }: SvgIconProps): React.ReactElement {
    return (
        <svg {...props} width={width ?? size ?? 22} height={height ?? size ?? 22} viewBox='0 0 22 22' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <title>{title}</title>
            <path
                d='M12.2205 7.60309C12.887 7.9213 13.4674 8.39481 13.9129 8.98384C14.3585 9.57287 14.6561 10.2602 14.7809 10.9882C14.9057 11.7161 14.854 12.4633 14.6302 13.1672C14.4063 13.871 14.0168 14.5108 13.4944 15.0328L8.87898 19.6482C8.01343 20.5137 6.83948 21 5.6154 21C4.39132 21 3.21738 20.5137 2.35182 19.6482C1.48626 18.7826 1 17.6087 1 16.3846C1 15.1605 1.48626 13.9866 2.35182 13.121L4.15387 11.319M17.8461 10.681L19.6482 8.87898C20.5137 8.01343 21 6.83948 21 5.6154C21 4.39132 20.5137 3.21738 19.6482 2.35182C18.7826 1.48626 17.6087 1 16.3846 1C15.1605 1 13.9866 1.48626 13.121 2.35182L8.50565 6.96719C7.98323 7.48924 7.59372 8.12904 7.36984 8.83285C7.14596 9.53666 7.09425 10.2839 7.21906 11.0118C7.34386 11.7398 7.64154 12.4271 8.08708 13.0162C8.53261 13.6052 9.113 14.0787 9.77949 14.3969'
                stroke={color ?? 'currentColor'}
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </svg>
    );
}
